import { getSiteById } from "react-migration/domains/sites/hooks/useSiteById";
import { getMapSiteSelectionLocation } from "react-migration/lib/util/getMapSiteSelectionLocation";
import ROUTES from "./routes";
import hasFeature from "../stores/user/actions/hasFeature";
import Feature from "../stores/user/Feature";

export const sharedSiteRedirect = async ({ routeName }: { routeName: string }) => {
  // Don't redirect if not on the share route or not logged in
  if (routeName !== ROUTES.SHARE || !hasFeature(Feature.landInsightAccess)) return;

  // Get the site id from the URL
  const pathname = window.location.pathname;
  const pathSegments = pathname.split("/");
  const shareIndex = pathSegments.indexOf("share");
  const siteId = shareIndex !== -1 && pathSegments[shareIndex + 1] ? pathSegments[shareIndex + 1] : undefined;

  if (!siteId) return;

  // Attempt to get the site from team sites, then from shared sites if no site is found
  const [privateSiteResponse, sharedSiteResponse] = await Promise.all([
    getSiteById(siteId, false),
    getSiteById(siteId, true),
  ]);

  const locationSite = privateSiteResponse?.location
    ? privateSiteResponse
    : sharedSiteResponse?.location
    ? sharedSiteResponse
    : null;

  if (!locationSite) return;

  // Redirect to the site on the map if the user has access
  return getMapSiteSelectionLocation({
    geometry: locationSite.geometry,
    siteLatLng: {
      lat: locationSite.location.coordinates[1],
      lng: locationSite.location.coordinates[0],
    },
    siteId,
    isShared: sharedSiteResponse?.sharedByUser?._id ? true : false,
  });
};
